import { AfterViewInit, Component, ElementRef, viewChild } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import {
  IonButton,
  IonButtons,
  IonHeader,
  IonSkeletonText,
  IonToolbar,
} from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NotificationService } from 'src/app/services/notification.service';
import { ParticipationService } from 'src/app/services/participation.service';
import { CurrentWhiteLabelApplication } from 'src/app/utils/current-white-label-application';
import { AppLinkComponent } from '../../app-link/app-link.component';
import { UserService } from '../../../services/user.service';
import { UserAvatarComponent } from '../../user-avatar/user-avatar.component';

@Component({
  standalone: true,
  selector: 'app-desktop-header',
  imports: [
    TranslateModule,
    RouterLink,
    IonHeader,
    IonToolbar,
    IonButtons,
    InlineSVGModule,
    AppLinkComponent,
    IonButton,
    UserAvatarComponent,
    IonSkeletonText,
  ],
  templateUrl: './desktop-header.component.html',
  styleUrl: './desktop-header.component.scss',
})
export class DesktopHeaderComponent implements AfterViewInit {
  public isProjectApp: boolean = false;
  public appIcon?: string;
  public appName: string;
  public appLogo?: string;
  public header = viewChild(IonHeader, {
    read: ElementRef,
  });

  public readonly user = this.userService.user;
  public readonly loadingUser = this.userService.loading;

  constructor(
    private app: CurrentWhiteLabelApplication,
    private participationService: ParticipationService,
    private notificationService: NotificationService,
    private userService: UserService,
    private router: Router
  ) {
    this.appName = this.app.getName();
    this.appIcon = this.app.getIconThumbnails()?.small;
    this.appLogo = this.app.getLogoThumbnails()?.compressed;
    this.isProjectApp = this.app.isProjectApp();
  }

  ngAfterViewInit() {
    requestAnimationFrame(() => {
      const el = this.header()?.nativeElement;
      if (el) {
        setTimeout(() => {
          document.documentElement.style.setProperty(
            '--desktop-header-height',
            `${el.offsetHeight}px`
          );
        });
      }
    });
  }

  goToLogin(event: MouseEvent) {
    event.preventDefault();
    this.router.navigate(['login']);
  }

  get participationOpenCount(): number {
    return this.participationService.openCount();
  }

  get unreadNotificationCount(): number {
    return this.notificationService.unreadCount();
  }
}
